import React, { useState } from 'react';
import {
    callAdminFailedPaymentListing,
  callAdminPaymentListing,
  callAdminRefundAmount,
  fileExport,
} from '../../api-services';
import RefundModal from './modal/RefundModal';
import Dropdown from 'react-bootstrap/Dropdown';
import { openUserDetailsModal } from '../../redux/features/modalSlice';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollar, faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { createTable } from '@tanstack/react-table';
import TableManager from '../../components/TableManager';
import swal from 'sweetalert';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';

const table = createTable();

const numberFilterTypes = [
  { label: 'Less Than', value: 'less_than' },
  { label: 'Greater Than', value: 'greater_than' },
  { label: 'Is Equal To', value: 'is_equal' },
  { label: 'Is Not Equal To', value: 'is_not_equal' },
  { label: 'Less or Equal to', value: 'less_or_equal' },
  { label: 'Greater or Equal to', value: 'greater_or_equal' },
];

const DateFilterTypes = [
  { label: 'Today', value: 'Today' },
  { label: 'Yesterday', value: 'Yesterday' },
  { label: 'Last 7 Days', value: 'Last 7 Days' },
  { label: 'Last 30 Days', value: 'Last 30 Days' },
  { label: 'This Month', value: 'This Month' },
  { label: 'Last Month', value: 'Last Month' },
  { label: 'Custom', value: 'Custom' },
];
const currencyOptions = [
  { label: 'EURO', value: 'EURO' },
  { label: 'XOF', value: 'XOF' },
  { label: 'USD', value: 'USD' },
  { label: 'GBP', value: 'GBP' },
  { label: 'NGN', value: 'NGN' },
];
const statusOptions = [
  { label: 'Completed', value: 'Completed' },
  { label: 'Pending', value: 'Pending' },
];
const statusOptionsType = [
  { label: 'Topup', value: 'Account Refill' },
  { label: 'Monthly Charge', value: 'Monthly Charge' },
  { label: 'Balance Deduct', value: 'Balance Deduct' },
];

const initialValues = {
  filter: [
    {
      account_number: '',
      a_filter_type: '',
      placeholder: 'Enter MSISDN...',
      type: 'number',
      shouldFilterOptionDisabled: false,
      filterOptions: numberFilterTypes,
      label: 'MSISDN',
    },
    {
      order_id: '',
      a_filter_type: '',
      placeholder: 'Enter OrderID',
      type: 'text',
      shouldFilterOptionDisabled: false,
      filterOptions: numberFilterTypes,
      label: 'OrderID',
    },
    {
      currency: '',
      a_filter_type: '',
      placeholder: 'Select Currency...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: currencyOptions,
      label: 'Currency',
    },
    {
      status: '',
      a_filter_type: '',
      placeholder: 'Select Status...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: statusOptions,
      label: 'Status',
    },
    {
      payment_type: '',
      a_filter_type: '',
      placeholder: 'Select Type...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: statusOptionsType,
      label: 'Type',
    },
    {
      date: {
        from: '',
        to: '',
      },
      a_filter_type: '',
      placeholder: 'Select Payment  Date...',
      type: 'date',
      shouldFilterOptionDisabled: false,
      filterOptions: DateFilterTypes,
      selectOptions: [],
      label: 'Payment Date',
    },
  ],
};

const FailedPayments = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openModalRefund, setOpenModalRefund] = useState(false);
  const [openModalRefundData, setOpenModalRefundData] = useState({});
  const [filters, setFilters] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);

  const { isLoading: isLoadingExporting, mutateAsync: mutateAsyncExport } =
    useMutation('fileExport', (payload) => fileExport(payload, 'payment'), {
      onSuccess: (data) => {
        window.open(data?.data?.data);
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    });
  const { mutateAsync } = useMutation('refund-amount', callAdminRefundAmount, {
    onSuccess: (data) => {
      swal({
        title: data?.data?.message,
        text: 'Your Amount Refunded Successfully ',
        icon: 'success',
      }).then(() => {
        navigate({
          pathname: '/history/refund',
        });
      });
    },
    onError: (error) => {
      swal({
        title: error?.response?.data?.message,
        type: 'danger',
        icon: 'error',
      });
    },
  });

  const handleRefundModal = (data) => {
    swal({
      text: `Are you sure you want to refund ${data?.currency} ${data?.total_amount}?`,
      buttons: true,
      icon: 'warning',
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          let payload = {
            invoice_number: data?.invoice_number,
          };

          await mutateAsync(payload);
        } catch (error) {
          console.log(error);
        }
      }
    });
    // setOpenModalRefund(true);
    // setOpenModalRefundData(data);
  };

  const handleOpenUserDetails = (shouldOpen, data) => {
    if (!shouldOpen) {
      return false;
    }

    dispatch(
      openUserDetailsModal({
        userModalOpen: true,
        userModalData: data,
      }),
    );
  };

  const columns = [
    table.createDataColumn((row) => row?.customer?.msisdn, {
      id: 'msisdn',
      header: 'MSISDN',
      shouldPointer: true,
      cell: (props) => {
        return (
          <span
            className="hover-name"
            onClick={() =>
              handleOpenUserDetails(
                props.getValue(),
                props?.row?.original?.customer,
              )
            }
          >
            {props.getValue()}
          </span>
        );
      },
    }),
   

    table.createDataColumn('payment_date', {
      id: 'payment_date',
      header: 'Payment Date',
      isSortable: true,
    }),
    table.createDataColumn('order_id', {
      id: 'order_id',
      header: 'OrderId',
      isSortable: true,
      cell:(props) => {
        return  props.getValue() || '---';
      }
    }),
    table.createDataColumn('token', {
      id: 'token',
      header: 'Token',
      isSortable: true,
    }),

    table.createDataColumn('amount', {
      id: 'amount',
      header: 'Total amount',
      textAlign: 'left',
      isSortable: true,
    }),
    table.createDataColumn('currency', {
      id: 'currency',
      header: 'Currency',
      textAlign: 'left',
    }),

    table.createDataColumn(
      (row) => {
        const data = row?.type === 'Account Refill' ? 'Topup' : row?.type;
        return data;
      },
      {
        id: 'type',
        header: 'Type',
        textAlign: 'left',
      },
    ),
    table.createDataColumn('payment_type', {
      id: 'payment_type',
      header: 'Payment Type',
      textAlign: 'left',
    }),

    table.createDataColumn('created_at', {
      id: 'status',
      header: 'Status',
      textAlign: 'left',
      cell:()=>{
        return 'Failed'
      }
      
    }),
    
  ];

  const handleFileExport = async (payload) => {
    await mutateAsyncExport(payload);
  };

  return (
    <>
      <TableManager
        table={table}
        columns={columns}
        filter={filters}
        fetcherKey="PaymentListing"
        fetcherFn={callAdminFailedPaymentListing}
        title="Failed Payment Report"
        shouldFilter={true}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        initialValues={initialValues}
        setFilters={setFilters}
        filters={filters}
        shouldExport={true}
        exportCtaFn={handleFileExport}
        isExporting={isLoadingExporting}
      />

      <RefundModal
        openModalRefund={openModalRefund}
        setOpenModalRefund={setOpenModalRefund}
        openModalRefundData={openModalRefundData}
        setOpenModalRefundData={setOpenModalRefundData}
      />
    </>
  );
};

export default FailedPayments;
